<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="ReplaceQuestionModal"
  >
    <template
      #modal-header
    >
      <h2 class="u-text-center">
        Replace Question
      </h2>
      <hr>
    </template>
    <template #modal-body>
      <div class="QuestionReplace-wrapper u-flex u-flex-spaceBetween">
        <div class="QuestionFrom-container">
          <h4>Replace</h4>
          <div class="list-group">
            <span class="Icon-s Icon-user" />

            <div class="list-group-item-details">
              <h3>
                {{ questionFrom.label }}
              </h3>
              <span class="Hint">
                {{ questionFrom.type }}
              </span>
            </div>
          </div>
        </div>
        <span class="ReplaceIcon Icon Icon-exchange-alt" />
        <div class="QuestionTo-container">
          <h4>With</h4>
          <div class="list-group">
            <span class="Icon-s Icon-user" />

            <div class="list-group-item-details">
              <h3>
                {{ questionTo.label }}
              </h3>
              <span class="Hint">
                {{ questionTo.type }}
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="Notice Notice--warning no-margin">
        <h3 class="Notice-header">
          Attention
        </h3>

        <p class="Notice-copy">
          1) The answer of the replaced question will be copied to the new question.
        </p>

        <p class="Notice-copy">
          2) If you <b>dont want</b> the answer of the replaced question to be copied over to the new question then consider deleting it instead.
        </p>

        <p class="Notice-copy">
          3) Once the event is saved, all existing records will be re-processed and the event will be locked.
        </p>

        <p class="Notice-copy">
          4) An event being locked does not stop incoming responses to be processed or students to register. It just means you are not able to edit it.
        </p>

        <p class="Notice-copy">
          5) Please beware that replacing questions may result in responses with validation errors, specifically of different types (eg: text for a select).
        </p>
      </div>
    </template>
    <template #modal-footer>
      <div class="u-floatLeft">
        <button
          class="Button Button--green-outline"
          @click="isOpen = false"
        >
          Cancel
        </button>
      </div>
      <div class="u-floatRight">
        <button
          class="Button Button--green"
          @click="handleReplaceQuestion"
        >
          Replace Question
        </button>
      </div>
    </template>
  </rmp-base-modal>
</template>
<script>
import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
  props: {
    questionFrom: {
      type: Object,
      default() {
        return {};
      },
    },
    questionTo: {
      type: Object,
      default() {
        return {};
      },
    },
    event: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    handleReplaceQuestion() {
      this.$emit('replace-question:submit', this.event.id);
    },
  },
};
</script>

<style lang="less" scoped>

.Notice--warning {
  margin-top: 20px;
}

.ReplaceIcon {
  padding: 15px;
  margin-top: 35px;
  border-radius: 50%;
  background-color: #E0E4EA;
}

.QuestionReplace-wrapper {
  align-items: center;
}

.QuestionFrom-container, .QuestionTo-container {
  flex-basis: 200px;
.Icon-s {
    background: #E0E4EA;
    font-size: 17px;
    border: 1px solid #D0D7E1;
    padding: 9px 12px;
    align-self: baseline;
    border-radius: 10px;
    margin-right: 10px;
  }
}
.list-group {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
  border: 1px solid #046FF0;
  border-radius: 6px;
  background-color: #E1EDFA;

  &.collapsed {
    display: none;
  }
  .list-group-item-details {

    h3 {
      margin: 0;
    }
}
}
</style>
